import { collection, getDocs, addDoc, doc, getDoc, query, where } from "firebase/firestore";
import { db, appId } from "../firebase";

/**
 * 데모 데이터 시딩 함수
 * 게스트 모드: localStorage에 저장
 * 인증 모드: Firestore에 저장 (조직 내 데이터가 없을 때만)
 */
export const seedDemoData = async (user) => {
    if (!user) return;

    // --- GUEST MODE (Local Storage) ---
    if (user.isAnonymous) {
        console.log("🌱 Seeding Demo Data to Local Storage...");

        const seedLocal = (key, data) => {
            if (!localStorage.getItem(key)) {
                localStorage.setItem(key, JSON.stringify(data));
            }
        };

        const demoStudents = [
            { id: "demo_s1", name: "오타니", gender: "남", grade: "청년부", class: "1반", phone: "010-1111-2222", birth: "1994-07-05", school: "하나마키히가시고등학교", address: "로스앤젤레스", faithState: "기존신자", notes: "성실함, 야구 좋아함", userId: 'guest', createdAt: new Date().toISOString() },
            { id: "demo_s2", name: "이강인", gender: "남", grade: "청소년부", class: "2반", phone: "010-3333-4444", birth: "2001-02-19", school: "인천석정초등학교", address: "파리", faithState: "기존신자", notes: "장난기 많음, 축구좋아함 ", userId: 'guest', createdAt: new Date().toISOString() },
            { id: "demo_s3", name: "장원영", gender: "여", grade: "고등부", class: "3반", phone: "010-5555-6666", birth: "2004-08-31", school: "서울공연예술고등학교", address: "서울", faithState: "초신자", notes: "찬양 좋아함, 활발함", userId: 'guest', createdAt: new Date().toISOString() }
        ];

        const demoTeacher = [
            { id: "demo_t1", name: "차범근", role: "부장", phone: "010-0909-0909", birth: "1953.05.22", address: "경기도 화성시", userId: 'guest', createdAt: new Date().toISOString() }
        ];

        seedLocal("guest_students", demoStudents);
        seedLocal("guest_teachers", demoTeacher);
        // Seed others empty to avoid null issues
        seedLocal("guest_schedules", []);
        seedLocal("guest_finances", []);
        seedLocal("guest_visitLogs", []);
        seedLocal("guest_meetingMinutes", []);
        seedLocal("guest_attendanceLogs", []);
        return;
    }

    // --- AUTH MODE (Firestore) ---
    try {
        // [FIX] db가 유효한지 먼저 확인
        if (!db) {
            console.warn("🌱 Firestore db not initialized. Skipping seed.");
            return;
        }

        // 1. Fetch User Profile to get Organization & Dept
        const userDocRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userDocRef);

        if (!userSnap.exists()) return;
        const userProfile = userSnap.data();
        const { organizationId, deptName, name: userName } = userProfile;

        // Only seed if user belongs to an organization and has a department
        if (!organizationId || !deptName) return;

        // 2. Check if data already exists in this organization
        const q = query(collection(db, "students"), where("organizationId", "==", organizationId));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
            console.log("🌱 Data exists. Skipping seed.");
            return;
        }

        console.log(`🌱 Seeding Demo Data for ${userName} in ${deptName}...`);

        // 3. Create Demo Students
        const demoStudents = [
            { name: "오타니", gender: "남", grade: deptName, class: "1반", phone: "010-1111-2222", birth: "1994-07-05", school: "다저스고", address: "LA", faithState: "기존신자", notes: "성실함, 투타겸업" },
            { name: "손흥민", gender: "남", grade: deptName, class: "2반", phone: "010-7777-7777", birth: "1992-07-08", school: "토트넘고", address: "런던", faithState: "기존신자", notes: "축구부 주장" },
            { name: "장원영", gender: "여", grade: deptName, class: "1반", phone: "010-1004-1004", birth: "2004-08-31", school: "서공예", address: "서울", faithState: "초신자", notes: "찬양팀 지원" },
            { name: "뉴진스", gender: "여", grade: deptName, class: "3반", phone: "010-2000-2000", birth: "2022-07-22", school: "어도어중", address: "서울", faithState: "학습교인", notes: "새가족" },
            { name: "페이커", gender: "남", grade: deptName, class: "2반", phone: "010-9999-9999", birth: "1996-05-07", school: "마포고", address: "서울", faithState: "기존신자", notes: "방송팀 봉사" }
        ];

        const batchPromises = demoStudents.map(student => {
            return addDoc(collection(db, "students"), {
                ...student,
                organizationId: organizationId,
                userId: user.uid,
                createdBy: user.uid,
                createdAt: new Date().toISOString()
            });
        });

        // Add a demo teacher as well
        const demoTeacher = {
            name: "차범근", role: "부장", phone: "010-0909-0909", birth: "1953-05-22",
            address: "경기도 화성", organizationId: organizationId,
            userId: user.uid, createdBy: user.uid, createdAt: new Date().toISOString()
        };
        batchPromises.push(addDoc(collection(db, "teachers"), demoTeacher));

        // Add a demo schedule
        const demoSchedule = {
            title: "새가족 환영회",
            date: new Date().toISOString().split('T')[0], // Today
            startTime: "14:00",
            category: "행사",
            location: "본당",
            content: "새로 온 친구들을 환영하는 시간",
            organizationId: organizationId,
            userId: user.uid, createdAt: new Date().toISOString()
        };
        batchPromises.push(addDoc(collection(db, "schedules"), demoSchedule));

        await Promise.all(batchPromises);
        console.log("✅ Demo Data Seeded Successfully!");

    } catch (e) {
        console.error("Error seeding demo data:", e);
    }
};
